"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleShowParties = exports.removeProjectCover = exports.uploadProjectCover = exports.deleteFolderShortcut = exports.addFolderShortcut = exports.fetchProjectGroups = exports.fetchProjectById = exports.fetchRoot = exports.fetchFolderShortcuts = void 0;
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const sok_types_1 = require("@caddigital/sok-types");
const ActionTypes = require("../../actionTypes/project/home");
const Actions = require("../../actions/project/home");
const errorHandling_1 = require("../../utils/errorHandling");
const translation_1 = require("../../utils/translation");
const toast_1 = require("../../actions/toast");
const MAX_COVER_IMAGE_SIZE = 1024 * 1024 * 10;
function fetchFolderShortcuts(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_PROJECT_SHORTCUTS_REQUEST), (0, operators_1.mergeMap)(({ payload }) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/project/${payload.projectId}/shortcuts`
    }).pipe((0, operators_1.mergeMap)((x) => {
        const validate = t.array(sok_types_1.File.iFolder).decode(x.response);
        const act = validate.fold((e) => Actions.fetchShortcutsFailure((0, errorHandling_1.parseValidationError)(e)), (c) => Actions.fetchShortcutsSuccess(c));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchShortcutsFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.fetchFolderShortcuts = fetchFolderShortcuts;
function fetchRoot(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_ROOT_REQUEST), (0, operators_1.mergeMap)(({ payload }) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/project/${payload.project.id}/root/${payload.feature}`
    }).pipe((0, operators_1.mergeMap)((x) => {
        const validate = sok_types_1.File.iFolder.decode(x.response);
        const act = validate.fold((e) => Actions.fetchRootFailure((0, errorHandling_1.parseValidationError)(e)), (c) => Actions.fetchRootSuccess(c));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchRootFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.fetchRoot = fetchRoot;
function fetchProjectById(action$, store, { ajax, getToken, baseUrl }) {
    return action$.ofType(ActionTypes.FETCH_PROJECT_BY_ID_REQUEST).pipe((0, operators_1.mergeMap)(({ payload }) => ajax({
        headers: {
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/project/${payload.projectId}`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        return sok_types_1.Project.iProject
            .decode(response)
            .fold((error) => (0, rxjs_1.of)(Actions.fetchProjectByIdFailure((0, errorHandling_1.parseValidationError)(error), payload.updateStatus)), (res) => (0, rxjs_1.of)(Actions.fetchProjectByIdSuccess(res, payload.updateStatus)));
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchProjectByIdFailure((0, errorHandling_1.parseAjaxErrorResponse)(error), payload.updateStatus))))));
}
exports.fetchProjectById = fetchProjectById;
function fetchProjectGroups(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_PROJECT_GROUPS_REQUEST), (0, operators_1.mergeMap)(({ payload }) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/project/${payload.projectId}/members?includeMembers=false&includeProjectAdmin`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        const validation = t
            .array(t.interface({
            group: sok_types_1.UserGroup.iUserGroup,
            members: t.array(sok_types_1.User.iUser)
        }))
            .decode(response);
        const act = validation.fold((e) => Actions.fetchProjectGroupsFailed((0, errorHandling_1.parseValidationError)(e)), (u) => Actions.fetchProjectGroupsSuccess(u));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchProjectGroupsFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.fetchProjectGroups = fetchProjectGroups;
function addFolderShortcut(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.ADD_SHORTCUTS_REQUEST), (0, operators_1.mergeMap)(({ payload }) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        body: payload,
        url: `${baseUrl}api/project/add-shortcut`
    }).pipe((0, operators_1.mergeMap)((x) => {
        const validate = t.array(t.number).decode(x.response);
        const act = validate.fold((e) => [Actions.addShortcutsFailed(e)], (c) => [
            Actions.addShortcutsSuccess(c),
            Actions.fetchShortcutsRequest(payload.projectId)
        ]);
        return (0, rxjs_1.of)(...act);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.addShortcutsFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.addFolderShortcut = addFolderShortcut;
function deleteFolderShortcut(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.DELETE_SHORTCUT_REQUEST), (0, operators_1.mergeMap)(({ payload }) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'DELETE',
        url: `${baseUrl}api/project/${payload.projectId}/shortcut/${payload.folderId}`
    }).pipe((0, operators_1.mergeMap)((x) => {
        const validate = t
            .interface({
            id: t.number
        })
            .decode(x.response);
        const act = validate.fold((e) => Actions.deleteShortcutFailed(e), (c) => {
            return Actions.deleteShortcutSuccess(c.id);
        });
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.deleteShortcutFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.deleteFolderShortcut = deleteFolderShortcut;
function uploadProjectCover(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.UPLOAD_PROJECT_COVER_REQUEST), (0, operators_1.mergeMap)((action) => (0, rxjs_1.of)(action).pipe((0, operators_1.mergeMap)((action) => t
        .type({
        type: t.literal(ActionTypes.UPLOAD_PROJECT_COVER_REQUEST),
        projectId: t.number,
        file: t.object
    })
        .decode(action)
        .fold(rxjs_1.throwError, () => (0, rxjs_1.of)(action))), (0, operators_1.mergeMap)((action) => {
        const data = new FormData();
        if (MAX_COVER_IMAGE_SIZE < action.file.size) {
            return (0, rxjs_1.merge)((0, rxjs_1.of)((0, toast_1.addNewToast)((0, translation_1.getLocalization)('toast/invalid_file'), (0, translation_1.getLocalization)('toast/filesize_exceeds_limit'), 'FAILURE', [])), (0, rxjs_1.of)(Actions.uploadProjectCoverFailure('err')));
        }
        data.append('file', action.file);
        return ajax({
            headers: {
                Authorization: getToken()
            },
            method: 'PUT',
            url: `${baseUrl}api/project/${action.projectId}/cover`,
            body: data
        }).pipe((0, operators_1.mergeMap)(({ response }) => (0, rxjs_1.of)(Actions.uploadProjectCoverSuccess(response.message))), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.uploadProjectCoverFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))));
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.uploadProjectCoverFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.uploadProjectCover = uploadProjectCover;
function removeProjectCover(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.REMOVE_PROJECT_COVER_REQUEST), (0, operators_1.mergeMap)((action) => (0, rxjs_1.of)(action).pipe((0, operators_1.mergeMap)((action) => t
        .type({
        type: t.literal(ActionTypes.REMOVE_PROJECT_COVER_REQUEST),
        projectId: t.number
    })
        .decode(action)
        .fold(rxjs_1.throwError, () => (0, rxjs_1.of)(action))), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            Authorization: getToken()
        },
        method: 'DELETE',
        url: `${baseUrl}api/project/${action.projectId}/cover`
    }).pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.of)(Actions.removeProjectCoverSuccess())), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.removeProjectCoverFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))))));
}
exports.removeProjectCover = removeProjectCover;
function toggleShowParties(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.TOGGLE_SHOW_PARTIES_REQUEST), (0, operators_1.mergeMap)((request) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        body: { showPartiesTab: request.payload.showPartiesTab },
        method: 'PUT',
        url: `${baseUrl}api/project/${request.payload.projectId}/toggle-show-parties`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        const validation = t
            .interface({
            projectId: t.number,
            showPartiesTab: t.boolean
        })
            .decode(response);
        const act = validation.fold((e) => Actions.toggleShowPartiesFailure((0, errorHandling_1.parseValidationError)(e)), (response) => Actions.toggleShowPartiesSuccess(response.projectId, response.showPartiesTab));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((e) => (0, rxjs_1.merge)((0, rxjs_1.of)((0, toast_1.addNewToast)((0, translation_1.getLocalization)('toast/toggle_show_parties_tab_failed'), (0, translation_1.getLocalization)('toast/toggle_show_parties_tab_failed_details'), 'FAILURE', [])), (0, rxjs_1.of)(Actions.toggleShowPartiesFailure((0, errorHandling_1.parseAjaxErrorResponse)(e))))))));
}
exports.toggleShowParties = toggleShowParties;
//# sourceMappingURL=home.js.map